import { Component } from '@angular/core';
import {
  DwComponent,
  DwComponentType,
  DwMetaDataListCardConfigData
} from '@devwareapps/devware-cap';

import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Course Card - Student Progress No Items',
  key: 'courseCard-StudentProgressNoItems',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Student,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-course-student-progress-no-items-card',
  templateUrl: './course-student-progress-no-items-card.component.html',
  styleUrls: ['./course-student-progress-no-items-card.component.scss']
})
export class CourseStudentProgressNoItemsCardComponent { }
